import React from 'react'
import { Modal, ModalBody, ModalFooter, ModalHeader, ModalTitle } from 'react-bootstrap'
import reactStringReplace from 'react-string-replace'
import ViewHandoverRegister from './ViewHandoverRegister'
import HandoverRegisterMessage from './HandoverRegisterMessage'

function HandoverRegisterModal({ onClose, UserAction, show, selectedRow, moduleName }) {
  let modalAction
  let showButtons
  const userAction = reactStringReplace(UserAction, 'User', () => '')

  if (UserAction === 'View') {
    modalAction = <ViewHandoverRegister handoverRegisterData={selectedRow} />
    showButtons = (
      <div>
        <button className="btn btn-cancel me-2" name="View" onClick={onClose}>Close</button>
      </div>
    )
  } else if (UserAction === 'Email') {
    modalAction = (
      <HandoverRegisterMessage
        handoverRegisterData={selectedRow}
        onCancel={onClose}
        onSent={onClose}
        moduleName={moduleName}
      />
    )
    showButtons = null
  }

  return (
    <Modal
      show={show}
      onHide={onClose}
      backdrop="static"
      dialogClassName="modal-dialog-centered stock-adjust-modal"
    >
      <ModalHeader className="modal-header border-0 custom-modal-header" closeButton>
        <ModalTitle>{userAction} {moduleName}</ModalTitle>
      </ModalHeader>
      <ModalBody>{modalAction}</ModalBody>
      <ModalFooter>{showButtons}</ModalFooter>
    </Modal>
  )
}

export default HandoverRegisterModal
